<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="370"
            id="createLeaveTypeDialog">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>
                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ header }}
                    </v-card-title>
                    <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid">
                        <v-text-field
                            :label="this.$vuetify.lang.t('$vuetify.leaveTypeFormModal.leaveType')"
                            v-model="form.name"
                            placeholder=" "
                            autocomplete="off"
                            :rules="inputRules"
                            :error-messages="errors.name">
                        </v-text-field>
                        <v-text-field
                            :label="this.$vuetify.lang.t('$vuetify.leaveTypeFormModal.numberOfDays')"
                            v-model="form.default_days"
                            placeholder=" "
                            :rules="dayRules"
                            @keydown="handlerInputNumber">
                        </v-text-field>
                        <v-text-field
                            v-if="isTigerReport"
                            label="ชนิด"
                            v-model="form.type"
                            placeholder=" "
                            autocomplete="off"
                            :rules="typeRules"
                            :error-messages="errors.type">
                        </v-text-field>
                        <v-switch
                            v-model="form.is_stack"
                            :label="`สะสมได้`">
                        </v-switch>
                        <v-switch
                            v-if="isTigerReport"
                            v-model="form.is_deduct"
                            :label="`หักเงิน`">
                        </v-switch>
                    </v-form>
                </div>
                <div class="modal-save-btn">
                    <v-btn
                        width="200"
                        color="primary"
                        @click="submitForm()">
                        {{ $vuetify.lang.t('$vuetify.leaveTypeFormModal.save') }}
                    </v-btn>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
    name: 'LeaveTypeFormModal',

    props: {
        mode: {
            type: String,
            default: null
        },

        updateLeaveTypeId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            dialog: false,
            valid: true,
            date: '',
            dateFormatted: '',
            datePickerShow: false,
            form: {
                name: '',
                default_days: '',
                is_stack: false,
                is_deduct: false,
                type: ''
            },
            inputRules: [
                v => this.$validator.hasValue(v, this.trans.leaveTypeFormModal.thisFieldIsRequired),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.leaveTypeFormModal.thisFieldIsExceededCharacters)
            ],
            dayRules: [
                v => this.$validator.hasValue(v, this.trans.leaveTypeFormModal.thisFieldIsRequired)
            ],
            typeRules: [
                v => this.$validator.hasValue(v, this.trans.leaveTypeFormModal.thisFieldIsRequired),
                v => /^[0-9]{2}$/.test(v) || 'กรุณากรอกตรงตามรูปแบบ 01 - 99'
            ],
            errors: []
        }
    },

    directives: {
        mask
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        header () {
            if (this.mode === 'create') {
                return this.$vuetify.lang.t('$vuetify.leaveTypeFormModal.createLeaveType')
            } else if (this.mode === 'update') {
                return this.$vuetify.lang.t('$vuetify.leaveTypeFormModal.updateLeaveType')
            }
            return ''
        },
        isTigerReport () {
            return process.env.VUE_APP_TIGER_HR === 'true'
        }
    },

    methods: {
        handlerInputNumber (event) {
            if (!new RegExp('^\\d$').test(event.key) &&
                event.key !== 'Backspace' &&
                event.key !== 'Tab' &&
                !event.ctrlKey &&
                !event.key.startsWith('Arrow')
            ) {
                event.preventDefault()
            }
        },

        closeModal () {
            this.clearForm()
            this.$refs.form.resetValidation()
            this.$emit('close-modal')
            this.dialog = false
        },

        clearForm () {
            this.form = {
                name: '',
                default_days: '',
                is_stack: false,
                is_deduct: false,
                type: ''
            }
            this.errors = []
        },

        cleanForm () {
            const keys = ['name']
            for (let i = 0; i < keys.length; i++) {
                this.form[keys[i]] = this.form[keys[i]].trim()
            }
        },

        async submitForm () {
            if (!this.$refs.form.validate()) {
                return
            }

            if (this.mode === 'create') {
                await this.createLeaveType()
                this.cleanForm()
            } else if (this.mode === 'update') {
                await this.updateLeaveType()
            }
        },

        async createLeaveType () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('leavetype/create', this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-created')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: this.trans.leaveTypeFormModal.congratulation,
                    text: this.trans.leaveTypeFormModal.leaveTypeIsCreated,
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.leaveTypeFormModal.errorMessage'),
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async updateLeaveType () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.put(`leavetype/edit/${this.updateLeaveTypeId}`, this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-updated')
                this.closeModal()
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.trans.leaveTypeFormModal.congratulation,
                    text: this.trans.leaveTypeFormModal.leaveTypeIsUpdated,
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.leaveTypeFormModal.errorMessage'),
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async getLeaveType (updateLeaveTypeId) {
            const res = await this.axios.get(`leavetype/${updateLeaveTypeId}`)
            if (res && res.data && res.data.status === 'ok') {
                const data = res.data.data
                this.form.name = data.name
                this.form.default_days = data.default_days
                this.form.is_stack = data.is_stack
                this.form.is_deduct = data.is_deduct
                this.form.type = data.type
            }
        }
    },

    mounted () {
        this.registerLang({
            leaveTypeFormModal: [
                'thisFieldIsRequired',
                'thisFieldIsExceededCharacters',
                'incorrectPhoneNubmer',
                'congratulation',
                'leaveTypeIsCreated',
                'leaveTypeIsUpdated',
                'errorMessage'
            ]
        })
    },

    watch: {
        async mode (newValue, oldValue) {
            if (newValue === 'create') {
                this.clearForm()
            } else if (newValue === 'update') {
                await this.getLeaveType(this.updateLeaveTypeId)
            }
        },
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$refs.form.resetValidation()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
